import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useLocalization } from '../context/LocalizationContext';
import { useTheme } from '../context/ThemeContext';

export const ThemeToggle = ({ compact = false, className = '' }) => {
  const { isDark, toggleTheme } = useTheme();
  const { t } = useLocalization();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`group inline-flex items-center justify-center rounded-xl border border-primary-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-primary-800 dark:text-primary-200 hover:bg-primary-50 dark:hover:bg-slate-800 transition-all ${
        compact ? 'h-10 w-10' : 'h-11 w-11'
      } ${className}`}
      title={isDark ? t('login.switchToLight') : t('login.switchToDark')}
      aria-label={isDark ? t('login.switchToLight') : t('login.switchToDark')}
      data-testid="theme-toggle-button"
    >
      {isDark ? (
        <Sun size={20} className="text-primary-500" strokeWidth={2} />
      ) : (
        <Moon size={20} className="text-primary-600" strokeWidth={2} />
      )}
    </button>
  );
};
